import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=5bba8547&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=5bba8547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba8547",
  null
  
)

export default component.exports